/* PPS product cards: hover/in-view video previews. Safe to include many times. */
(function () {
  if (window.__ppsCardsJs) return; window.__ppsCardsJs = true;
  var canHover = window.matchMedia('(hover: hover)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  function play(card) {
    var v = card.querySelector('.pps-card__vid'); if (!v) return;
    if (!v.src && !v.__ppsLoading) {
      // Liquid only exposes the full-size file; ask the product JSON for the lightest (~480p) version.
      v.__ppsLoading = true;
      var url = card.querySelector('a[href*="/products/"]');
      var h = url ? url.getAttribute('href').split('?')[0] : '';
      fetch(h + '.js').then(function (r) { return r.json(); }).then(function (j) {
        var best = null;
        (j.media || []).forEach(function (m) { if (m.media_type !== 'video') return; (m.sources || []).forEach(function (s) {
          if (s.format === 'mp4' && s.height >= 360 && (!best || s.height < best.height)) best = s; }); });
        v.src = best ? best.url : v.getAttribute('data-src');
        if (card.__ppsWant) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
      }).catch(function () { v.src = v.getAttribute('data-src'); });
    }
    if (!v.__ppsBound) {
      v.__ppsBound = true;
      // Magic Wand videos have a slow intro: start (and loop back) at 5 seconds.
      var link = card.querySelector('a[href*="/products/"]');
      var start = link && /magic-wand/.test(link.getAttribute('href')) ? 5 : 0;
      if (start) {
        v.removeAttribute('loop'); v.loop = false;
        v.addEventListener('loadedmetadata', function () { if (v.duration > start + 1 && v.currentTime < start) v.currentTime = start; });
        v.addEventListener('ended', function () { v.currentTime = v.duration > start + 1 ? start : 0; if (card.__ppsWant) v.play(); });
      }
      v.addEventListener('playing', function () { if (card.__ppsWant) card.classList.add('is-playing'); });
    }
    card.__ppsWant = true;
    if (v.src) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function stop(card) {
    var v = card.querySelector('.pps-card__vid'); if (!v) return;
    card.__ppsWant = false; v.pause(); card.classList.remove('is-playing');
  }
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var c = e.target.closest && e.target.closest('.pps-card--video');
      if (c && !c.contains(e.relatedTarget)) play(c);
    });
    document.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest('.pps-card--video');
      if (c && !c.contains(e.relatedTarget)) stop(c);
    });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.intersectionRatio >= 0.75 ? play(en.target) : stop(en.target); });
    }, { threshold: [0, 0.75] });
    var watch = function () { document.querySelectorAll('.pps-card--video:not([data-pps-io])').forEach(function (c) { c.setAttribute('data-pps-io', '1'); io.observe(c); }); };
    watch(); new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
  }
})();
